export const LIST_WIDGET_LAYOUT = {
  ITEMS_PER_ROW: 1,
  ROW_GAP: 24,
  COLUMN_GAP: 24,
} as const;
